export const PAGE_SEO = {
  home: {
    title: "General Contractor & Remodeling in Huntsville, AL | Noyola Construction LLC",
    description: "Noyola Construction LLC is a trusted remodeling contractor in Huntsville, AL. Shower & bathroom remodeling, laminate, LVP & tile flooring, roofing, painting and fence installation across North Alabama. Free estimates — call (256) 755-2458.",
  },
  about: {
    title: "About Us | Noyola Construction LLC — Remodeling Contractor in Huntsville, AL",
    description: "Meet Noyola Construction LLC, a residential remodeling and home improvement contractor serving Huntsville and North Alabama with quality workmanship and clear communication.",
  },
  services: {
    title: "Construction & Remodeling Services in Huntsville, AL | Noyola Construction LLC",
    description: "Shower remodeling, laminate & LVP flooring installation, tile installation, roofing, house painting and fence installation in Huntsville, AL and North Alabama. Request a free estimate.",
  },
  projects: {
    title: "Project Gallery | Remodeling, Flooring, Roofing & Fencing in Huntsville, AL",
    description: "Browse real Noyola Construction projects in Huntsville and North Alabama: shower remodels, tile work, LVP flooring, painting, roofing and fence installations.",
  },
  beforeAfter: {
    title: "Before & After Transformations | Home Remodeling in Huntsville, AL",
    description: "See real before & after home remodeling transformations by Noyola Construction LLC in Huntsville, AL — custom showers, tile, flooring and more.",
  },
  reviews: {
    title: "Customer Reviews | Noyola Construction LLC — Huntsville & Madison, AL",
    description: "Read real customer reviews of Noyola Construction LLC, a remodeling contractor serving Huntsville, Madison and North Alabama homeowners.",
  },
  estimate: {
    title: "Request a Free Estimate | Noyola Construction LLC — Huntsville, AL",
    description: "Get a free estimate for shower remodeling, flooring, tile, roofing, painting or fence installation in Huntsville, AL. Fast response — call (256) 755-2458 or send your project details.",
  },
  contact: {
    title: "Contact Noyola Construction LLC | Huntsville, AL — (256) 755-2458",
    description: "Contact Noyola Construction LLC, general contractor in Huntsville, AL. Call (256) 755-2458 or request a free estimate for remodeling, flooring, roofing, painting or fencing.",
  },
};

const AREA_EN = "Proudly serving Huntsville, Madison and surrounding North Alabama communities.";
const AREA_ES = "Sirviendo con orgullo a Huntsville, Madison y las comunidades cercanas del norte de Alabama.";

export const SERVICE_SEO = {
  "shower-remodeling": {
    title: "Shower Remodeling in Huntsville, AL | Bathroom Renovation — Noyola Construction",
    description: "Professional shower remodeling and bathroom renovation in Huntsville, AL. Full tear-out, waterproofing, custom tile, glass enclosures and LED lighting. Free estimates — (256) 755-2458.",
    content: {
      en: {
        heading: "Shower & Bathroom Remodeling in Huntsville, AL",
        intro: "From complete tear-outs to the final bead of caulk, Noyola Construction handles every stage of your shower renovation in-house. We prep with cement board and proper waterproofing so your new shower looks great and lasts for decades.",
        points: [
          "Full shower tear-out, cement board and waterproofing prep",
          "Custom tile and marble shower walls and floors",
          "Glass enclosures and modern fixtures",
          "LED lighting, niches and built-in shelving",
          "Shower valve and plumbing fixture installation",
          "Complete bathroom remodeling",
        ],
        area: AREA_EN,
      },
      es: {
        heading: "Remodelación de duchas y baños en Huntsville, AL",
        intro: "Desde la demolición completa hasta el último detalle, Noyola Construction se encarga de cada etapa de la renovación de su ducha. Preparamos con placa de cemento e impermeabilización adecuada para que su nueva ducha luzca increíble y dure décadas.",
        points: [
          "Demolición completa, placa de cemento e impermeabilización",
          "Paredes y pisos de ducha en azulejo y mármol a medida",
          "Mamparas de vidrio y accesorios modernos",
          "Iluminación LED, nichos y repisas integradas",
          "Instalación de válvulas y grifería de ducha",
          "Remodelación completa de baños",
        ],
        area: AREA_ES,
      },
    },
  },
  "flooring-lvp-tile": {
    title: "Laminate, LVP & Tile Flooring Installation in Huntsville, AL | Noyola Construction",
    description: "Flooring contractor in Huntsville, AL: laminate flooring, LVP (luxury vinyl plank) and porcelain or ceramic tile installation with proper subfloor prep. Free estimates — (256) 755-2458.",
    content: {
      en: {
        heading: "Flooring Installation in Huntsville, AL",
        intro: "Whether you want the warmth of laminate, the durability of luxury vinyl plank or the timeless look of tile, our flooring installers deliver level, tight, long-lasting floors with clean transitions and trim.",
        points: [
          "Laminate flooring installation",
          "LVP (luxury vinyl plank) flooring installation",
          "Porcelain and ceramic tile installation",
          "Subfloor preparation and leveling",
          "Transitions, baseboards and trim",
          "Kitchens, bathrooms and whole-home flooring",
        ],
        area: AREA_EN,
      },
      es: {
        heading: "Instalación de pisos en Huntsville, AL",
        intro: "Ya sea la calidez del piso laminado, la durabilidad del vinilo de lujo (LVP) o el estilo clásico del azulejo, nuestros instaladores entregan pisos nivelados, firmes y duraderos con transiciones y molduras limpias.",
        points: [
          "Instalación de piso laminado",
          "Instalación de piso LVP (vinilo de lujo)",
          "Instalación de azulejo de porcelana y cerámica",
          "Preparación y nivelación del subsuelo",
          "Transiciones, zócalos y molduras",
          "Cocinas, baños y pisos para toda la casa",
        ],
        area: AREA_ES,
      },
    },
  },
  roofing: {
    title: "Roofing Contractor in Huntsville, AL | Roof Replacement & Repair — Noyola Construction",
    description: "Roofing services in Huntsville, AL: roof replacement, roof repair and inspections for residential properties in North Alabama. Free estimates — call (256) 755-2458.",
    content: {
      en: {
        heading: "Roofing Services in Huntsville, AL",
        intro: "Your roof is your home's first line of defense against Alabama weather. Noyola Construction provides dependable roofing work — from targeted repairs to full roof replacement — done right the first time.",
        points: [
          "Roof replacement",
          "Roof repair and leak fixes",
          "Roof inspections and honest assessments",
          "Residential roofing for homes across North Alabama",
        ],
        area: AREA_EN,
      },
      es: {
        heading: "Servicios de techado en Huntsville, AL",
        intro: "Su techo es la primera línea de defensa de su hogar contra el clima de Alabama. Noyola Construction ofrece trabajos de techado confiables — desde reparaciones puntuales hasta el reemplazo completo del techo — bien hechos desde la primera vez.",
        points: [
          "Reemplazo de techos",
          "Reparación de techos y filtraciones",
          "Inspecciones de techo y evaluaciones honestas",
          "Techado residencial en todo el norte de Alabama",
        ],
        area: AREA_ES,
      },
    },
  },
  painting: {
    title: "Painting Contractor in Huntsville, AL | Interior & Exterior House Painting",
    description: "House painting in Huntsville, AL: interior painting, exterior painting, accent walls and surface prep by Noyola Construction LLC. Free estimates — (256) 755-2458.",
    content: {
      en: {
        heading: "Interior & Exterior Painting in Huntsville, AL",
        intro: "A professional paint job transforms a space. We take prep seriously — patching, sanding and priming — so the finish is smooth, even and made to last, inside and out.",
        points: [
          "Interior house painting",
          "Exterior painting",
          "Accent walls and color consultations",
          "Surface prep, patching and priming",
          "Trim, doors and detail work",
          "Residential and commercial painting",
        ],
        area: AREA_EN,
      },
      es: {
        heading: "Pintura interior y exterior en Huntsville, AL",
        intro: "Un trabajo de pintura profesional transforma un espacio. Nos tomamos en serio la preparación — resanado, lijado e imprimación — para lograr un acabado liso, uniforme y duradero, por dentro y por fuera.",
        points: [
          "Pintura interior de casas",
          "Pintura exterior",
          "Paredes de acento y asesoría de color",
          "Preparación de superficies, resanado e imprimación",
          "Molduras, puertas y trabajo de detalle",
          "Pintura residencial y comercial",
        ],
        area: AREA_ES,
      },
    },
  },
  "fence-installation": {
    title: "Fence Installation in Huntsville, AL | Fence Contractor — Noyola Construction",
    description: "Fence contractor in Huntsville, AL: wooden privacy fences, custom gates, fence repair and replacement for homes in North Alabama. Free estimates — (256) 755-2458.",
    content: {
      en: {
        heading: "Fence Installation in Huntsville, AL",
        intro: "Add privacy, security and curb appeal with a fence built to stand straight for years. We set posts properly, build clean lines and craft custom gates that match your property.",
        points: [
          "Wooden privacy fence installation",
          "Custom wooden gates",
          "Fence repair and replacement",
          "Property line and backyard fencing",
        ],
        area: AREA_EN,
      },
      es: {
        heading: "Instalación de cercas en Huntsville, AL",
        intro: "Agregue privacidad, seguridad y atractivo a su propiedad con una cerca construida para mantenerse firme por años. Colocamos los postes correctamente, construimos líneas limpias y fabricamos portones a medida.",
        points: [
          "Instalación de cercas de privacidad de madera",
          "Portones de madera a medida",
          "Reparación y reemplazo de cercas",
          "Cercas para límites de propiedad y patios",
        ],
        area: AREA_ES,
      },
    },
  },
};
